<template>
  <div class="coupon-wrapper" :class="{ hot: hot }">
    <div class="left-tip" :class="{ hot: hot }">
      <span>立省¥</span>{{ price.originPrice - price.sellPrice }}
      <span class="triangle" />
    </div>
    <div class="title">
      {{ title.mainTitle }}
    </div>
    <div class="sub-title">
      {{ title.subTitle }}
    </div>
    <div class="content">
      <div class="coupons" @click="handleGoDetail">
        <div
          v-for="(item, index) in detail.couponList"
          :key="index"
          class="coupon-item"
        >
          <div class="price"><span class="unit">¥</span>{{ item.value }}</div>
          <div class="threshold">满{{ item.threshold }}可用</div>
          <div class="line-top" />
          <div class="name">
            {{ item.name }}
          </div>
          <div class="subscript">{{ item.num }}张</div>
        </div>
      </div>
      <div class="footer">
        <div class="left">
          <div v-if="status === 6" class="count-down">
            <div class="desc will-buy">
              <span>距开始还剩</span>
            </div>
            <count-down :time="detail.leftTime">
              <template slot-scope="scope">
                <span class="number">{{ scope.count.endH }}</span>
                <i class="interval">:</i>
                <span class="number">{{ scope.count.endM }}</span>
                <i class="interval">:</i>
                <span class="number">{{ scope.count.endS }}</span>
              </template>
            </count-down>
          </div>
          <div v-if="status === 1" class="progress-wrap">
            <my-progress :percent="detail.percent" />
            <span class="text">已售{{ detail.percent }}%</span>
          </div>
        </div>
        <div
          class="btn"
          :class="{ 'no-buy': status === 2 || status === 3 }"
          @click="handleGoDetail"
        >
          <div class="btn-left">
            <div class="price-new"><span>¥</span>{{ price.sellPrice }}</div>
            <div class="price-old">¥{{ price.originPrice }}</div>
          </div>
          <div v-show="status !== 6" class="btn-right">
            {{ status | getText }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Progress from './Progress.vue'
import CountDown from './CountDown.vue'

// 1:可购买，2:已购买，3:已抢光，6:未开始
export default {
  name: 'CouponPackage',
  components: {
    MyProgress: Progress,
    CountDown
  },
  filters: {
    getText(value) {
      switch (value) {
        case 1:
          return '去抢购'
        case 2:
          return '已购买'
        case 3:
          return '已售罄'
        default:
          return ''
      }
    }
  },
  props: {
    detail: {
      type: Object,
      default: () => {}
    },
    hot: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      status: this.detail.status
    }
  },
  computed: {
    isValid() {
      if (this.status === 2 || this.status === 3) return 'invalid'
      return 'valid'
    },
    price() {
      return this.detail.price || {}
    },
    title() {
      return this.detail.title || {}
    }
  },
  methods: {
    handleCountDown() {
      this.status = 1
    },
    handleGoDetail() {
      this.$router.push({
        name: 'memberCouponpackDetail',
        query: {
          id: this.detail.activityId
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.coupon-wrapper {
  position: relative;
  margin-bottom: 0.32rem;
  padding: 0.2rem;
  width: 7.1rem;
  height: 4.5rem;
  background-image: url('~@/images/couponPack/coupon_pack@3x.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  border-radius: 0.24rem;
  box-sizing: border-box;
  &:nth-last-child(1) {
    margin-bottom: 0;
  }
  &.hot {
    background-image: url('~@/images/couponPack/hot_coupon_pack@3x.png');
    .title {
      color: #fff;
    }
    .sub-title {
      color: #fff;
    }
  }
  .left-tip {
    position: absolute;
    top: 0.24rem;
    right: -0.1rem;
    width: 1.8rem;
    height: 0.6rem;
    line-height: 0.6rem;
    color: #fff;
    font-size: 0.32rem;
    text-align: center;
    background-image: linear-gradient(to right, #ff4c2d 0%, #ff7d5e 100%);
    border-radius: 0.4rem 0.1rem 0 0.4rem;
    box-shadow: 0 2px 4px 0 rgba(200, 138, 45, 0.4);
    span {
      font-size: 0.24rem;
    }
    .triangle {
      position: absolute;
      right: 2px;
      bottom: -3px;
      height: 0;
      width: 0;
      border-right: 3px solid #cc1f00;
      border-left: 3px solid transparent;
      border-bottom: 3px solid transparent;
      border-top: 3px solid transparent;
      transform: rotate(45deg);
    }
    &.hot {
      background-image: linear-gradient(to right, #ffbe14 0%, #ffd25b 100%);
      box-shadow: 0 2px 4px 0 rgba(193, 36, 0, 0.4);
      .triangle {
        border-right: 3px solid #cb6600;
      }
    }
  }
  .title {
    font-size: 0.32rem;
    line-height: 0.32rem;
    color: #333;
    font-weight: 600;
  }
  .sub-title {
    margin-top: 0.16rem;
    font-size: 0.24rem;
    line-height: 0.24rem;
    color: #333;
  }
  .content {
    margin-top: 0.18rem;
    height: 3.2rem;
    border-radius: 0.2rem;
    background: #ffff;
    .coupons {
      padding: 0.28rem 0 1px;
      overflow-x: auto;
      white-space: nowrap;
      .coupon-item {
        display: inline-block;
        font-size: 0;
        margin-left: 0.2rem;
        position: relative;
        width: 1.64rem;
        height: 1.68rem;
        background-color: rgba(255, 92, 0, 0.06);
        border: 1px solid rgba(255, 92, 0, 0.2);
        border-radius: 0.12rem;
        color: #333;
        &:nth-last-child(1) {
          margin-right: 0.2rem;
        }
        .price {
          margin-top: 0.22rem;
          font-size: 0.4rem;
          text-align: center;
          .unit {
            font-size: 0.28rem;
          }
        }
        .threshold {
          margin: 0.1rem 0 0.08rem;
          font-size: 0.24rem;
          text-align: center;
        }
        .line-top {
          border-top: 1px dashed rgba(255, 221, 202, 0.5);
        }
        .name {
          margin: 0 0.1rem;
          text-align: center;
          overflow: hidden;
          font-size: 0.24rem;
          line-height: 0.44rem;
          height: 0.44rem;
          color: #666;
          box-sizing: border-box;
        }
        .subscript {
          position: absolute;
          top: -1px;
          right: -1px;
          width: 0.5rem;
          height: 0.28rem;
          text-align: center;
          line-height: 0.28rem;
          color: #fff;
          font-size: 0.2rem;
          border-radius: 0 0.12rem 0 0.12rem;
          background-image: linear-gradient(to right, #ff4d2d 0%, #ff8541 100%);
        }
      }
    }
    .footer {
      margin-top: 0.24rem;
      padding: 0 0.2rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 0.8rem;
      .text {
        font-size: 0.24rem;
        color: #666;
      }
      .count-down {
        display: flex;
        align-items: center;
        .will-buy {
          margin-right: 0.08rem;
          font-size: 0.24rem;
        }
        .number {
          width: 0.5rem;
          line-height: 0.3rem;
          font-weight: 600;
          font-size: 0.24rem;
        }
        .interval {
          margin: 0 0.04rem;
          font-size: 0.2rem;
          font-weight: 600;
        }
      }
      .btn {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 2.74rem;
        height: 0.8rem;
        background: linear-gradient(to right, #ff4c2d 0%, #ff7d5e 100%);
        border-radius: 0.4rem;
        &.no-buy {
          background: #ccc;
        }
      }
      .price-new {
        font-size: 0.36rem;
        line-height: 0.36rem;
        color: #fff;
        span {
          font-size: 0.24rem;
          line-height: 0.24rem;
        }
      }
      .price-old {
        font-size: 0.24rem;
        color: #fff;
        text-decoration: line-through;
      }
      .btn-left {
        text-align: center;
      }
      .btn-right {
        margin-left: 0.14rem;
        font-size: 0.32rem;
        color: #fff;
      }
    }
  }
}
</style>
